import { graphql } from "../../generated/gql";

export const TranslateTextGQL = graphql(`
  mutation TranslateText($input: TranslateTextInput!) {
    translateText(input: $input) {
      translatedText
    }
  }
`);
